var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCombinedShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "14px",
    viewBox: "0 0 11 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D12EA38D-AA78-4587-BE1B-2CE30A2B4191") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-System",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-1-4-DhurvStar-Design-System",
    transform: "translate(-660.000000, -356.000000)",
    fill: "#081981"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M668.489961,356.190497 C668.829107,355.940868 669.272037,355.936066 669.615771,356.179101 C669.920145,356.394306 670.09375,356.764967 670.09375,357.154015 L670.09375,357.154015 L670.09375,368.658486 C670.09375,369.047534 669.920145,369.418195 669.615771,369.6334 C669.272037,369.876435 668.829107,369.871633 668.487531,369.620205 L668.487531,369.620205 L664.458,366.618 L664.444493,366.617605 C664.381833,366.607056 664.322897,366.585537 664.269729,366.555092 L661.032986,366.554982 C660.461345,366.554982 660.039806,366.063925 660.002666,365.484231 L660.002666,365.484231 L660,365.400858 L660,360.417872 C660,359.802685 660.434124,359.263748 661.032986,359.263748 L661.032986,359.263748 L664.261501,359.26222 C664.320269,359.227152 664.386379,359.203109 664.456975,359.192947 Z M669.027531,357.114563 L665.064,360.066 L665.064,365.745 L669.027531,368.697407 L669.03125,368.658486 L669.03125,357.154015 L669.027531,357.114563 Z M664.002,365.492 L664.002,360.326 L661.032986,360.326248 C661.068714,360.326248 661.066166,360.338282 661.063718,360.38038 L661.0625,360.417872 L661.0625,365.400858 L661.064773,365.456977 C661.065952,365.484125 661.062759,365.492482 661.032986,365.492482 L661.032986,365.492482 L664.002,365.492 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombinedShape);
export default __webpack_public_path__ + "static/media/Combined Shape.0e19f24ab9cb03c0b2f93a835d70fa9d.svg";
export { ForwardRef as ReactComponent };